import React from 'react';
import { tokens } from '../theme';

export function Table({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        overflowX: 'auto',
        borderRadius: tokens.radius.base,
        border: `1px solid ${tokens.color.line[100]}`,
        background: tokens.color.paper['00'],
      }}
    >
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
        {children}
      </table>
    </div>
  );
}

type Align = 'left' | 'right' | 'center';

export function Th({
  children,
  align = 'left',
}: {
  children: React.ReactNode;
  align?: Align;
}) {
  return (
    <th
      style={{
        textAlign: align,
        padding: '16px 16px',
        fontSize: 11,
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: tokens.color.ink[500],
        borderBottom: `1px solid ${tokens.color.line[100]}`,
        background: tokens.color.paper[50],
        fontWeight: 500,
      }}
    >
      {children}
    </th>
  );
}

export function Td({
  children,
  align = 'left',
}: {
  children: React.ReactNode;
  align?: Align;
}) {
  return (
    <td
      style={{
        padding: '16px 16px',
        borderBottom: `1px solid ${tokens.color.line[100]}`,
        color: tokens.color.ink[900],
        textAlign: align,
        verticalAlign: 'middle',
      }}
    >
      {children}
    </td>
  );
}
